import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';
import settings from '@/modules/fictitious/settings';
import reports from '@/modules/fictitious/reports';

const route: RouteObject = {
	path: 'fictitious',
	loader: () => ({
		meta: {
			title: 'Fictitious',
			to: { id: 'fictitiousHome' },
			htmlTitlePattern: '#title :: Fictitious',
		} as RouteMeta,
	}),
	lazy: async () => ({ Component: (await import('@/modules/fictitious/Layout')).default }),
	children: [
		{
			path: '',
			index: true,
			id: 'fictitiousHome',
			loader: () => ({
				meta: {
					title: 'Home',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/fictitious/pages/Home')).default }),
		},
		{
			path: 'leads',
			id: 'fictitiousLeads',
			index: true,
			loader: () => ({
				meta: {
					title: 'Leads',
					htmlTitle: `Leads`,
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/fictitious/pages/Leads')).default }),
		},
		{
			path: '',
			shouldRevalidate: () => true,
			loader: ({ params }) => ({
				meta: {
					title: params.abbreviation,
					to: { id: 'fictitiousStateHome', params: { abbreviation: params.abbreviation } },
				} as RouteMeta,
			}),
			children: [
				{
					path: ':abbreviation',
					id: 'fictitiousStateHome',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Home',
							htmlTitle: `${params.abbreviation} Home`,
							disabled: true,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/fictitious/pages/StateHome')).default }),
				},
				{
					path: ':abbreviation/orders',
					id: 'fictitiousOrders',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Orders',
							htmlTitle: `${params.abbreviation} Orders`,
							disabled: true,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/fictitious/pages/Orders')).default }),
				},
				{
					path: ':abbreviation/mailings',
					id: 'fictitiousMailings',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Mailings',
							disabled: true,
							htmlTitle: `${params.abbreviation} Mailings`,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/fictitious/pages/Mailings')).default }),
				},
				{
					path: ':abbreviation/entities',
					id: 'fictitiousEntities',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Entities',
							disabled: true,
							htmlTitle: `${params.abbreviation} Entities`,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/fictitious/pages/Entities')).default }),
				},
				{
					path: ':abbreviation/:entityID',
					id: 'FictitiousEntityProfile',
					index: true,
					loader: ({ params }) => ({
						meta: {
							title: 'Profile',
							disabled: true,
							htmlTitle: `${params.abbreviation} Profile`,
						} as RouteMeta,
					}),
					lazy: async () => ({ Component: (await import('@/modules/fictitious/pages/Profile')).default }),
				},
			],
		},
		settings,
		reports,
	],
};
export default route;
